var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup26685(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_26685",
    "data-name": "Group 26685",
    transform: "translate(-56 -880)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_237",
    "data-name": "Ellipse 237",
    cx: 36,
    cy: 36,
    r: 36,
    transform: "translate(56 880)",
    fill: "#8430c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23259",
    "data-name": "Path 23259",
    d: "M877.164,85.366a4.794,4.794,0,0,1-4.755,4.787h-5.841a4.958,4.958,0,0,0-4.463,7.21c1.385,2.718-.1,6.251-3.114,6.72-9.314,1.444-21.61-8.771-18.965-22.475a18.768,18.768,0,0,1,37.138,3.759m-28.2,2.367a2.375,2.375,0,0,0-2.345-2.279,2.346,2.346,0,0,0,.066,4.692,2.3,2.3,0,0,0,2.279-2.412m2.411-9.312a2.345,2.345,0,1,0-2.345,2.345,2.343,2.343,0,0,0,2.345-2.345m9.38-4.687a2.345,2.345,0,1,0-2.345,2.342,2.343,2.343,0,0,0,2.345-2.342m9.38,4.687a2.345,2.345,0,1,0-2.345,2.345,2.343,2.343,0,0,0,2.345-2.345",
    transform: "translate(-766.661 830.306)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup26685);
export default __webpack_public_path__ + "static/media/Group 26685.c9dff42e08c50e6abc24f4c9e33203b6.svg";
export { ForwardRef as ReactComponent };